<template>
  <div>
    <div class="Tranbox">
      <div class="Tranboxtitle">Transactions</div>
      <div class="Tranboxlist">
        <div class="Tranbox_left">
          <Listbox style="width: 486px; height: 131px; background: #13161b">
            <template #headers> Txn Count </template>
            <template #leftcon>
              {{ Number(totalTxCount).toLocaleString() }}
            </template>
            <template #lefttit> Total </template>
            <template #rightcon>
              +{{ Number(yesterdayTxCount).toLocaleString() }}
            </template>
            <template #footers> Last 24h </template>
          </Listbox>
          <listbox style="width: 486px; height: 131px; background: #13161b">
            <template #headers>Trading Volume</template>
            <template #leftcon> {{ totalTradingValume }} TTOS</template>
            <template #lefttit> Total </template>
            <template #rightcon>
              <span v-if="yesterdayTradingValume.length > 3">{{
                yesterdayTradingValume
              }}</span
              ><span v-else>{{ yesterdayTradingValume }}</span> TTOS
            </template>
            <template #footers> Last 24h </template>
          </listbox>
        </div>
        <div class="Tranbox_right">
          <div class="chartsbox">
            <div class="chartsbox_left">Daily Txn Distribution</div>
            <!-- <div class="chartsbox_right">
              <span>More</span><img src="@/assets/pc/Index/more.png" />
            </div> -->
          </div>
          <div class="charts">
            <div
              id="charts"
              ref="chart"
              style="width: 613px; height: 250px"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="Blocks">
      <div class="Block_Top notranslate">
        <span class="notranslate">Transactions {{ Tiaoshu }}</span>
      </div>
      <div v-show="list.length > 0">
        <div class="Block_list">
          <ul class="block_list_Top">
            <li>Txn Hash</li>
            <li>Block</li>
            <li class="xila">Type</li>
            <li>Age</li>
            <li>From</li>
            <li>To</li>
            <li>Amount</li>
            <!-- <li>Gas</li> -->
          </ul>
        </div>
        <div class="Block_List_center notranslate">
          <ul>
            <li v-for="(item, index) in list" :key="index">
              <p>
                <span @click="TxHash(index)">{{ item.txHash }}</span>
              </p>

              <p>
                <router-link
                  :to="{
                    name: 'BkHeight',
                    query: { height: item.height },
                  }"
                >
                  {{ item.height }}
                </router-link>
              </p>

              <p>{{ item.type }}</p>
              <p>
                {{ item.tradeTime }}
                <!-- <span class="Hover1">
                  <span class="Hover"
                    >{{ TimeDate[index] }}<i class="iconfont">&#xe600;</i></span
                  >
                </span> -->
              </p>
              <p>
                <span
                  @click="Address(index)"
                  v-if="
                    item.type != 'Unstake' &&
                    item.fromAddress != 'Unpledge' &&
                    item.type != 'Bonus'
                  "
                >
                  {{ item.fromAddress }}
                </span>
                <span class="yanca" v-if="item.type == 'Bonus'">Bonus</span>
                <span v-if="item.type == 'Unstake'" class="yanca">Unstake</span>
              </p>
              <p v-if="item.toAddress !== '...'">
                <span
                  @click="Address2(index)"
                  :class="
                    item.type != 2 && (item.toAddress1 != 'Pledge') != ''
                      ? 'active'
                      : ''
                  "
                  v-if="item.toAddress1 != 'Gas' && item.toAddress1 != 'Pledge'"
                  >{{ item.toAddress }}</span
                >
                <span style="color: #898b8d" v-else>{{
                  item.toAddress1 === "Gas" ? "Signature Rewards" : "Stake"
                }}</span>
              </p>
              <p v-else>
                <span style="color: #898b8d">{{ item.toAddress }}</span>
              </p>
              <!-- 代币 -->
              <p v-if="item.standard == 'ERC-721' && item.type1 == 7">
                <img
                  :src="item.logo"
                  v-if="item.tokenAmount == ''"
                  style="width: 34px; height: 34px; border-radius: 50%"
                />
                <img
                  :src="item.logo"
                  v-if="item.tokenAmount !== ''"
                  style="width: 34px; height: 34px; border-radius: 4px"
                /><span style="margin-top: 4px"
                  >{{ item.contractName }} {{ item.tokenAmount }}</span
                >
              </p>
              <p
                v-if="item.standard == 'ERC-20' && item.type1 == 7"
                style="color: #fff; cursor: pointer"
                @click="cHash1(index)"
              >
                <!-- @click="cHash1(index)" -->
                <!-- 不需要点击 -->
                <!-- <p
                v-if="item.standard == 'ERC-20' && item.type1 == 7"
               
              > -->
                <!-- {{ item.tokenAmount }} -->
                {{ item.tokenAmount }}
                <img
                  :src="item.logo"
                  style="width: 34px; height: 34px; border-radius: 50%"
                />
                <span v-if="item.symbol.length > 10"
                  >{{ item.symbol.slice(0, 10) }}...</span
                >
                <span v-else style="margin-top: 5px">{{ item.symbol }}</span>
                <!-- {{ item.symbol }} -->
              </p>
              <p
                v-if="item.standard == 'ERC-20' && item.type1 == 8"
                @click="cHash1(index)"
                style="color: #fff; cursor: pointer"
              >
                {{ item.tokenAmount }}
                <!-- aaaa  {{ item.tokenAmount }} -->
                <!-- <span v-if="item.tokenAmount.length<8"> {{ Number(item.tokenAmount).toLocaleString() }} </span>
              <span v-else>{{ (item.tokenAmount) }}</span> -->
                <img
                  :src="item.logo"
                  style="width: 24px; height: 24px; border-radius: 50%"
                />{{ item.symbol }}
              </p>
              <!-- 合约执行 -->
              <p
                v-if="
                  item.standard == 'ERC-721' &&
                  item.type1 == 8 &&
                  item.tokenAmount !== ''
                "
                style="color: #fff; cursor: pointer"
                @click="cHash(index)"
              >
                <!-- <img
                v-if="item.tokenAmount ==''"
                  :src="item.logo"
                  style="width: 34px; height: 34px; border-radius: 50%"
                /> -->
                <img
                  v-if="item.tokenAmount !== ''"
                  :src="item.logo"
                  style="
                    height: 34px;
                    border-radius: 4px;
                    border: 1px solid #000;
                  "
                /><span style="margin-top: 4px"
                  >{{ item.contractName }}
                  <span v-if="item.tokenAmount.length > 10">
                    {{ item.tokenAmount.split(",")[0] }}</span
                  >
                  <span v-else>{{ item.tokenAmount }}</span>
                </span>
              </p>
              <!-- 不被识别的合约类型 -->
              <p
                v-if="
                  item.standard == 'ERC-721' &&
                  item.type1 == 8 &&
                  item.functions == 'Contract Execute'
                "
              >
                <!-- <img
                v-if="item.tokenAmount ==''"
                  :src="item.logo"
                  style="width: 34px; height: 34px; border-radius: 50%"
                /> -->

                <img
                  v-if="item.nftImageList == ''"
                  :src="imgurl"
                  style="height: 34px; border-radius: 50%"
                />
                <img
                  v-if="item.nftImageList !== ''"
                  :src="item.logo"
                  style="height: 34px; border-radius: 50%"
                />

                <span style="margin-top: 4px">{{ item.contractName }}</span>
              </p>
              <!-- 不被识别的合约类型 -->
              <!-- 类型为8和ERC-721 functions setBaseTokenURI functions balanceOf -->
              <p
                v-if="
                  item.standard == 'ERC-721' &&
                  item.type1 == 8 &&
                  (item.functions == 'setBaseTokenURI' ||
                    item.functions == 'balanceOf')
                "
              >
                <!-- <img
                v-if="item.tokenAmount ==''"
                  :src="item.logo"
                  style="width: 34px; height: 34px; border-radius: 50%"
                /> -->
                <img
                  :src="item.logo"
                  style="
                    width: 34px;
                    height: 34px;
                    border-radius: 4px;
                    border: 1px solid #000;
                  "
                />

                <span style="margin-top: 4px">{{ item.contractName }} </span>
              </p>
              <!-- <p
                v-if="(item.standard == 'ERC-721' && item.type1 == 8)&&item.tokenAmount ==''"
              
              >
              <img
                  :src="item.logo"
                  v-if="item.tokenAmount ==''"
                  style="width: 34px; height: 34px; border-radius: 4px;"
                />
                <img
                  :src="item.logo"
                  v-if="item.tokenAmount !==''"
                  style="width: 34px; height: 34px; border-radius: 4px"
                />
                
                <span style="margin-top: 4px"
                  >{{ item.contractName }} {{ item.tokenAmount }}</span
                >
              </p> -->
              <p
                v-if="
                  (item.type1 !== 8 || item.type1 !== 7) && item.standard == ''
                "
              >
                <span v-if="item.amount.length > 3">
                  {{
                    new Intl.NumberFormat("en-US", {
                      minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                      maximumFractionDigits: 10,
                    }).format(item.amount)
                  }}</span
                >
                <span v-else>
                  {{
                    new Intl.NumberFormat("en-US", {
                      minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                      maximumFractionDigits: 10,
                    }).format(item.amount)
                  }}</span
                >
                <!-- <span v-if="item.amount.length>3"> {{ Number(item.amount.slice(0,8)).toLocaleString() }}</span>
                <span v-else>{{ Number(item.amount.slice(0,8)).toLocaleString() }}</span> -->
                TTOS
              </p>
            </li>
          </ul>
        </div>
        <div :class="list.length > 10 ? 'Block_List_Bottom' : ''">
          <el-pagination
            ref="Pagination"
            :page-size="20"
            :current-page.sync="PaginationIndex"
            background
            layout="prev, pager,
      next"
            @current-change="CurrentChange"
            :total="total1"
          >
          </el-pagination>
        </div>
      </div>
      <div v-show="list.length <= 0">
        <EmptyState />
      </div>
    </div>
  </div>
</template>

<script>
import Listbox from "../../../components/pc/Listbox.vue";
import Pagination from "../BlockList/Pagination";
import Pagination2 from "../BlockList/Pagination2.vue";
import EmptyState from "../EmptyState/EmptyState.vue";
import { TradeList, GetTxList } from "@/assets/server/api";
import {
  timestampConvertTime,
  formatSeconds,
  getSubStr,
  listType,
  countDecimalPlaces,
} from "@/utils/utils";
import { TypeTxsList } from "@/assets/server/api.js";
const echarts = require("echarts");
export default {
  props: ["List", "tradeNums"],
  data() {
    return {
      list: [],
      Time: [],
      PaginationIndex: 1,
      total1: null,
      Type: "",
      txHash: [],
      fromAddress: [],
      toAddress: [],
      data: [],
      data2: [],
      data3: [],
      ToList: 0,
      Tiaoshu: "",
      Page1: "",
      TimeDate: [],
      ImgUrl4: require("@/assets/pc/TopValidators/xiala2.png"), //向下下拉箭头
      imgurl: require("@/assets/pc/Index/indexlogo.png"),
      imgurl1: require("@/assets/pc/Index/nft.png"),
      calendarDatas: [
        {
          name: "ALL",
          value: "",
        },
        {
          name: "Signature Rewards",
          value: 1,
        },
        {
          name: "Transfer",
          value: 2,
        },
        {
          name: "Bonus",
          value: 3,
        },
        {
          name: "Delegate ",
          value: 4,
        },
        {
          name: "Withdraw",
          value: 5,
        },
        {
          name: "Stake",
          value: 1,
        },
        {
          name: "Unstake",
          value: 2,
        },
      ],
      value: "",
      //交易列表开始
      yesterdayTradingValume: "",
      totalTxCount: "",
      totalTradingValume: "",
      yesterdayTxCount: "",
      todayCallContractCount: 0, // 合约调用次数
      todayClaimingBonusCount: 0, //图表 申领奖励次数
      todayInvestAndDisInvestCount: 0, //图表  投资和解投资次数
      todayStakeAndUnstakeCount: 0, //图表  质押和解质押次数
      todayTransferCount: 0, //图表  转账次数
      pastdays: "",
      //交易列表结束
    };
  },
  components: {
    Pagination,
    Pagination2,
    EmptyState,
    Listbox,
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  watch: {},
  created() {
    this.PaginationIndex = 1;
    // this.TransactionsList();
  },
  mounted() {
    //  this.initCharts();
    this.GetTranstionlist();
  },
  methods: {
    check_is_img(url) {
      return (
        url.match(/\.(jpeg|jpg|gif|png|GIF|PNG|JPG|JPEG|SVG|svg)$/) != null
      );
    },
    cHash1(index) {
      //  console.log(111);
      let params = {
        contractAddress: this.list[index].contractAddress,
      };
      this.$router.push({ path: "/pc/Overview", query: params });
    },
    cHash(index) {
      // if(this.list[index].type1==8 && this.list[index].standard=='ERC-20'){
      //   console.log(111);
      //   let params = {
      //   contractAddress: this.list[index].contractAddress,
      // };
      // this.$router.push({ path: "/pc/Overview", query: params });

      // }else
      if (
        this.list[index].type1 == 8 &&
        this.list[index].standard == "ERC-721"
      ) {
        let params = {
          contractAddress: this.list[index].contractAddress,
          tokenId: this.list[index].tokenAmount,
        };
        //   console.log(params);
        this.$router.push({ path: "/pc/NFTslistdetail", query: params });
        //   let params = {
        //   contractAddress: this.list[index].contractAddress,
        // };
        // this.$router.push({ path: "/pc/NFTsdetail", query: params });
      }
      // else if(this.list[index].type1==7){
      //   let params = {
      //   contractAddress: this.list[index].contractAddress,
      //   };
      //   this.$router.push({ path: "/pc/Overview", query: params });
      // }
    },
    initCharts() {
      //    console.log(this.pastdays);
      this.lineChart = echarts.init(this.$refs.chart);
      var data = [
        {
          value: this.todayTransferCount,
          name: "Transfer",
          time: this.pastdays,
        },
        {
          value: this.todayStakeAndUnstakeCount,
          name: "Staking/Unstaking",
          time: this.pastdays,
        },
        {
          value: this.todayInvestAndDisInvestCount,
          name: "Delegation/Withdrawal",
          time: this.pastdays,
        },
        {
          value: this.todayClaimingBonusCount,
          name: "Claiming bonuses",
          time: this.pastdays,
        },
        {
          value: this.todayCallContractCount,
          name: "Triggering  smart contracts",
          time: this.pastdays,
        },
      ];
      //     console.log(data);
      let option = {
        tooltip: {
          // trigger: "item",
          backgroundColor: "rgba(36,41,49,0.9)", //设置背景图片 rgba格式
          color: "rgba(255, 255, 255, 0.5)",
          // borderWidth: "1", //边框宽度设置1
          // borderColor: "gray", //设置边框颜色
          formatter: function (params) {
            //       console.log(params);
            //  console.log(params.data.name);
            // console.log(params[0].value);
            // console.log(this.pastdays);
            let str =
              '<p style="width:200px;height:100px;">' +
              '<span style="color:#fff;font-size:12px;">' +
              params.data.time +
              "(UTC)" +
              "</span>" +
              "</br>" +
              "<span style='color:#fff'>" +
              params.marker +
              params.data.name +
              "</span>" +
              "<br/>" +
              '<span style="color:#fff;font-size:12px;margin-left:16px;">' +
              "Percentage :" +
              params.percent +
              "%" +
              "</span>" +
              "<br/>" +
              '<span style="color:#fff;margin-left:16px">' +
              "Txn Counts :" +
              new Intl.NumberFormat("en-US", {
                minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                maximumFractionDigits: 10,
              }).format(params.data.value) +
              "</span>" +
              "</p>";
            return str;
          },
        },
        legend: {
          show: true,
          selectedMode: false,
          orient: "vertical",
          x: "40%", //可设定图例在左、右、居中
          y: "center",
          icon: "circle",
          padding: [0, 50, 0, 0],
          itemHeight: 10, // 图例icon高度
          itemWidth: 9, // 图例icon宽度
          //  align: "right", // 图例icon在左侧
          // itemGap: 20, // 图例每项之间的间隔。
          itemHeight: 18, //  图例标记的图形高度。
          formatter: function (name) {
            //          console.log(name);
            // 添加
            let total = 0;
            let target;
            for (let i = 0; i < data.length; i++) {
              total += data[i].value;
              //         console.log(total);
              if (data[i].name === name) {
                target = data[i].value;
              }
            }
            // console.log(0/0);
            if (total == 0) {
              var arr = [
                "{a|" + name + "}",
                "{b|" + target + "}{c|" + 0 + "%}",
              ];
              //  console.log(arr);
              return arr.join("  ");
            } else {
              var arr = [
                "{a|" + name + "}",
                "{b|" +
                  new Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                    maximumFractionDigits: 10,
                  }).format(target) +
                  "}{c|(" +
                  ((target / total) * 100).toFixed(2) +
                  "%)}",
              ];
              // console.log(arr);
              return arr.join("  ");
            }
          },
          textStyle: {
            // 添加
            padding: [0, 0, 0, 0],
            rich: {
              a: {
                fontSize: 15,
                width: 140,
                height: 24,
                color: "#898B8D",
                align: "left",
              },
              b: {
                fontSize: 15,
                width: 128,
                height: 24,
                color: "#fff",
                align: "right", //3.右对齐
                // padding: [0, -10, 0, 0],
              },
              c: {
                fontSize: 15,
                // width: 100,
                height: 24,
                color: "#8E9093",
                align: "right",
              },
            },
          },
        },
        color: ["#00C785", "#14C9C9", "#F7BA1E", "#722ED1", "#3491FA"],
        series: [
          {
            // name: "Access From",
            type: "pie",

            radius: ["22%", "70%"],
            center: ["22%", "48%"],

            roseType: "radius",
            // itemStyle: {
            //   borderRadius: 5,
            // },
            label: {
              show: false,
            },
            emphasis: {
              label: {
                show: true,
              },
            },
            minAngle: 0.01,

            itemStyle: {
              normal: {
                borderWidth: 1,
                borderColor: "#232a35",
                color: function (colors) {
                  var colorList = [
                    "#00C785",
                    "#14C9C9",
                    "#F7BA1E",
                    "#722ED1",
                    "#3491FA",
                  ];
                  return colorList[colors.dataIndex];
                },
              },
            },
            // avoidLabelOverlap: false,

            // minAngle: 1,
            // itemStyle: {

            //   borderWidth: 2,
            // },
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "40",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: data,
          },
        ],
      };
      this.lineChart.setOption(option);
    },
    GetTranstionlist() {
      let _this = this;
      const params = {
        pageNum: _this.PaginationIndex,
        pageSize: 20,
      };
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      GetTxList(formData).then((res) => {
      //     console.log(res);

        // console.log(res.result.increaseVolume);
        if (parseFloat(res.result.increaseVolume) > 1000000) {
          this.yesterdayTradingValume =
            Number(
              (parseFloat(res.result.increaseVolume) / 1000000).toFixed(3)
            ).toLocaleString() + "m";
        } else if (parseFloat(res.result.increaseVolume) > 100000000) {
          this.yesterdayTradingValume =
            Number(
              (parseFloat(res.result.increaseVolume) / 100000000).toFixed(3)
            ).toLocaleString() + "b";
        } else if (parseFloat(res.result.increaseVolume) < 1000000) {
          this.yesterdayTradingValume = parseFloat(
            res.result.increaseVolume
          ).toFixed(3);
        }
        if (parseFloat(res.result.totalVolume) > 1000000) {
          this.totalTradingValume =
            Number(
              (parseFloat(res.result.totalVolume) / 1000000).toFixed(3)
            ).toLocaleString() + "m";
        } else if (parseFloat(res.result.totalVolume) > 100000000) {
          this.totalTradingValume =
            Number(
              (parseFloat(res.result.totalVolume) / 100000000).toFixed(3)
            ).toLocaleString() + "b";
        } else if (parseFloat(res.result.totalVolume) < 1000000) {
          this.totalTradingValume = parseFloat(res.result.totalVolume).toFixed(
            3
          );
        }

        //   console.log(this.yesterdayTradingValume);

        // this.yesterdayTradingValume = parseFloat(
        //   res.result.increaseVolume
        // ).toFixed(3);

        // if (Number(this.yesterdayTradingValume) > 0) {
        //   this.yesterdayTradingValume = "+" + this.yesterdayTradingValume;
        // }
        this.totalTxCount = res.result.totalTxCount;
        //     console.log(this.totalTxCount);
        //   this.totalTradingValume = parseFloat(res.result.totalVolume).toFixed(3);
        //      console.log(this.totalTradingValume);
        this.yesterdayTxCount = res.result.yesterdayTxCount;
        this.pastdays = res.result.dailyTxnDistribution.pastTime;
        //       console.log(this.pastdays);
        //      console.log(res.result.dailyTxnDistribution);
        this.todayCallContractCount =
          res.result.dailyTxnDistribution.todayCallContractCount;
        this.todayClaimingBonusCount =
          res.result.dailyTxnDistribution.todayClaimingBonusCount;
        this.todayInvestAndDisInvestCount =
          res.result.dailyTxnDistribution.todayInvestAndDisInvestCount;
        this.todayStakeAndUnstakeCount =
          res.result.dailyTxnDistribution.todayStakeAndUnstakeCount;
        this.todayTransferCount =
          res.result.dailyTxnDistribution.todayTransferCount;
        this.initCharts();

        _this.list = res.result.txList;
        //   console.log(_this.list);

        this.Tiaoshu = Number(res.result.totalTxCount).toLocaleString();
        this.Tiaoshu = "(" + this.Tiaoshu + ")";
        _this.total1 = res.result.totalTxCount;
        //     console.log(_this.total1);
        var calctime = new Date();
        let strdate = Math.floor(calctime.getTime() / 1000);
        for (let i = 0; i < _this.list.length; i++) {
          // console.log( JSON.parse(_this.list[i].nftImageList));
          // console.log( JSON(_this.list[i].nftImageList));

          if (_this.list[i].type1 == "8") {
            _this.list[i].fromEvmAddress1 = _this.list[i].fromEvmAddress;
            _this.list[i].fromEvmAddress = getSubStr(
              _this.list[i].fromEvmAddress,
              0,
              6
            );
            //  _this.list[i].
            _this.list[i].toEvmAddress1 = _this.list[i].toEvmAddress;
            _this.list[i].toEvmAddress = getSubStr(
              _this.list[i].toEvmAddress,
              0,
              6
            );
          }
          let UTCTime =
            res.result.txList[i].tradeTime - _this.getClientTimezone * 3600000;
          _this.TimeDate[i] = timestampConvertTime(UTCTime);
          let timestamp = Math.floor(
            _this.gltime(_this.list[i].tradeTime) / 1000
          );
          var s = strdate - timestamp;
          if (s <= 0) {
            s = 1;
          }
          _this.list[i].tradeTime = formatSeconds(s);
          _this.list[i].txHasha = _this.list[i].txHash;
          _this.list[i].txHash = getSubStr(_this.list[i].txHash, 0, 6);
          if (
            _this.list[i].tokenAmount.length >= 8 
          ) {
            _this.list[i].tokenAmount =
              Number(_this.list[i].tokenAmount.slice(0, 8)) +
              "...";
            // _this.list[i].tokenAmount.slice(0, 8) + "...";
          } else {
            _this.list[i].tokenAmount = _this.list[i].tokenAmount.slice(0, 7);
          }
          // _this.list[i].tokenAmount =(parseFloat( _this.list[i].tokenAmount.split(",")[0])).toFixed(8);
          //  if(countDecimalPlaces(_this.list[i].tokenAmount)>8){
          //   _this.list[i].tokenAmount =Number((_this.list[i].tokenAmount).toString().match(/^\d+(?:\.\d{0,8})?/));
          //   }
          //this.list1[i].tokenAmount=   Number((this.list1[i].tokenAmount).toString().match(/^\d+(?:\.\d{0,7})?/));

          // _this.list[i].fromAddress1 = _this.list[i].fromAddress;
          // _this.list[i].fromAddress = getSubStr(
          //   _this.list[i].fromAddress,
          //   0,
          //   6
          // );

          // console.log(_this.list[i].toAddress);
          // _this.list[i].toAddress1 = _this.list[i].toAddress;
          // _this.list[i].toAddress = getSubStr(_this.list[i].toAddress, 0, 6);

          if (_this.list[i].type == 7) {
            _this.list[i].amount = "0";
          } else if (_this.list[i].type == 8) {
            _this.list[i].amount = "0";
          }
          _this.list[i].type1 = _this.list[i].type;
          if (_this.list[i].type == 8) {
            _this.list[i].toAddress = _this.list[i].toEvmAddress;
            _this.list[i].fromAddress = _this.list[i].fromEvmAddress;

            _this.list[i].type = _this.list[i].functions;
          }
          _this.list[i].toAddress1 = _this.list[i].toAddress;
          _this.list[i].fromAddress1 = _this.list[i].fromAddress;
          _this.list[i].fromAddress = getSubStr(
            _this.list[i].fromAddress,
            0,
            6
          );
          _this.list[i].toAddress = getSubStr(_this.list[i].toAddress, 0, 6);

          _this.list[i].type = listType(_this.list[i].type);
          if (_this.list[i].logo == "" && _this.list[i].type == "mint") {
            _this.list[i].logo = _this.imgurl1;
          }

          if (_this.list[i].logo == "" && _this.list[i].type !== "mint") {
            _this.list[i].logo = _this.imgurl;
          }
          if (
            _this.list[i].type1 == "8" &&
            _this.list[i].standard == "ERC-721" &&
            _this.list[i].nftImageList !== ""
          ) {
            var images = JSON.parse(_this.list[i].nftImageList);
            // console.log(images);
            _this.list[i].logo = images[0];
            _this.list[i].nftNameList = JSON.parse(_this.list[i].nftNameList);

            _this.list[i].contractName = _this.list[i].nftNameList[0];
          } else {
            if (_this.list[i].type == "mint") {
              _this.list[i].logo = _this.imgurl1;
            }
            if (_this.list[i].functions == "transferFrom") {
              _this.list[i].logo = _this.imgurl1;
            }
            // _this.list[i].logo=_this.imgurl1;
          }
          if (
            _this.list[i].standard !== "ERC-20" &&
            (_this.list[i].logo == "" || _this.list[i].logo) == false
          ) {
            if (_this.list[i].type1 == 7) {
              _this.list[i].logo = this.imgurl;
            } else {
              _this.list[i].logo = this.imgurl1;
            }
          }
          //判断合约名字为空的时候
          if (
            _this.list[i].type1 == "7" &&
            _this.list[i].standard == "ERC-721"
          ) {
            // console.log(333);
            if (_this.list[i].contractName == "") {
              _this.list[i].contractName = getSubStr(
                _this.list[i].contractAddress,
                0,
                3
              );
            }
          }
          if (
            _this.list[i].type1 == "7" &&
            _this.list[i].standard == "ERC-20" &&
            _this.list[i].contractName == ""
          ) {
            // console.log(2222);
            if (_this.list[i].symbol == "") {
              _this.list[i].symbol = getSubStr(
                _this.list[i].contractAddress,
                0,
                3
              );
            }
          }
          //合约不被识别的时候
          if (
            _this.list[i].type1 == "8" &&
            _this.list[i].standard == "ERC-721" &&
            _this.list[i].functions == "Contract Execute"
          ) {
            if (_this.list[i].logo == "") {
              _this.list[i].logo = this.imgurl;
            }
          }
          //合约里面没有sybol的
          if (
            _this.list[i].type1 == "8" &&
            _this.list[i].standard == "ERC-20"
          ) {
            if (_this.list[i].tokenAmount > 999) {
              _this.list[i].tokenAmount = Number(
                _this.list[i].tokenAmount
              ).toLocaleString();
            }
            if (_this.list[i].symbol.trim() == "") {
              if (_this.list[i].contractName.trim() !== "") {
                _this.list[i].symbol = _this.list[i].contractName;
              } else {
                _this.list[i].symbol = getSubStr(
                  _this.list[i].contractAddress,
                  0,
                  3
                );
              }
            }
            //   if (_this.list[i].logo == " " && _this.list[i].functions == "mint") {
            //   _this.list[i].logo = _this.imgurl1;
            // }
            // if(_this.list[i].contractName.trim() !==''){
            //   if(_this.list[i].symbol.trim()==''){
            //     _this.list[i].symbol= _this.list[i].contractName;
            //   }
            // }else{
            //   _this.list[i].symbol= getSubStr( _this.list[i].contractAddress,0,3);
            // }
          }

          //判断如果type=99时候为申领交易
          // if( _this.list[i].type=="Bonus" &&  _this.list[i].fromAddress=="Bonus"){
          //   _this.list[i].type1=99;
          // }
          // console.log(_this.list[i]);
        }
      });
    },
    CurrentChange(val) {
      //  console.log(val);
      this.PaginationIndex = val;
      // this.setContextData("tiaozhuan2", this.PaginationIndex);
      this.GetTranstionlist();
    },

    gltime(i) {
      const toDate = new Date(i);
      var d = toDate;
      var localTime = d.getTime();
      var localOffset = d.getTimezoneOffset() * 60000;
      var utc = localTime + localOffset;
      var offset = this.getClientTimezone;
      var korean = utc + 3600000 * offset;
      var nd = korean;
      return nd;
    },

    TxHash(index) {
      //   console.log(this.list);
      let params = {
        txHash: this.list[index].txHasha,
        type: this.list[index].type1,
        standard: this.list[index].standard,
      };
      //   console.log(params);
      this.$router.push({ path: "/pc/To", query: params });
    },
    // getSubStr(str) {
    //   var subStr1 = str.substr(0, 5);
    //   var subStr2 = str.substr(str.length - 5, 5);
    //   var subStr = subStr1 + "..." + subStr2;
    //   return subStr;
    // },
    // getSubStr2(str) {
    //   var subStr1 = str.substr(0, 5);
    //   var subStr2 = str.substr(str.length - 5, 5);
    //   var subStr = subStr1 + "..." + subStr2;
    //   return subStr;
    // },
    // getSubStr3(str) {
    //   var subStr1 = str.substr(0, 5);
    //   var subStr2 = str.substr(str.length - 5, 5);
    //   var subStr = subStr1 + "..." + subStr2;
    //   return subStr;
    // },
    Address(index) {
      let params = this.list[index].fromAddress1;
      //   console.log(params);
      this.$router.push({ path: "/pc/BkHash", query: { query: params } });
    },
    Address2(index) {
      //   console.log(this.list[index].toAddress);
      let params = this.list[index].toAddress1;
      this.$router.push({ path: "/pc/BkHash", query: { query: params } });
    },
    // tiaozhuan1(e) {
    //   this.PaginationIndex = e;
    // //  this.TransactionsList();
    // },
    setContextData: function (key, value) {
      if (typeof value == "string") {
        sessionStorage.setItem(key, value);
      } else {
        sessionStorage.setItem(key, JSON.stringify(value));
      }
    },
    getContextData: function (key) {
      const str = sessionStorage.getItem(key);
      if (typeof str == "string") {
        try {
          return JSON.parse(str);
        } catch (e) {
          return str;
        }
      }
      return;
    },
  },
};
</script>

<style lang="less" scoped>
.Tranbox {
  width: 1160px;
  height: 398px;
  background: #000000;
  border-radius: 20px 20px 20px 20px;
  opacity: 1;
  margin-bottom: 20px;
  .Tranboxtitle {
    margin-left: 20px;
    padding-top: 30px;
    font-size: 18px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
  }
  .Tranboxlist {
    display: flex;
    justify-content: space-between;
    .Tranbox_left {
      margin-top: 30px;
      margin-left: 20px;
      .Tranbox_box {
        width: 486px;
        height: 131px;
        background: #13161b;
        border-radius: 12px 12px 12px 12px;
        opacity: 1;
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        .Tranbox_boxl {
          margin-top: 20px;
          margin-left: 20px;
          .Tranbox_title {
            font-size: 12px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.5);
            height: 17px;
            line-height: 17px;
          }
          .Tranbox_num {
            font-size: 24px;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #00e79a;
            margin-top: 8px;
            height: 35px;
            line-height: 35px;
            margin-bottom: 14px;
          }
          .Tranbox_tt {
            height: 17px;
            font-size: 12px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.5);
            line-height: 17px;
          }
        }
        .Tranbox_boxr {
          margin-right: 20px;
          margin-top: 45px;
          .Tranbox_rnum {
            height: 35px;
            font-size: 24px;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #00e79a;
            line-height: 35px;
            margin-bottom: 14px;
          }
          .Tranbox_time {
            height: 17px;
            font-size: 12px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.5);
            line-height: 17px;
            text-align: right;
          }
        }
      }
    }
    .Tranbox_right {
      width: 614px;
      height: 282px;
      background: #13161b;
      border-radius: 12px 12px 12px 12px;
      opacity: 1;
      margin-right: 20px;
      margin-top: 30px;
      .chartsbox {
        display: flex;
        margin: 20px 20px 0 20px;
        justify-content: space-between;
        .chartsbox_left {
          font-size: 12px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.5);
        }
        .chartsbox_right {
          width: 51px;
          height: 25px;
          background: #000000;
          border-radius: 6px 6px 6px 6px;
          opacity: 1;
          line-height: 25px;
          text-align: center;
          font-size: 12px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
          display: flex;
          span {
            margin-left: 5px;
            display: block;
          }
          img {
            width: 18px;
            height: 18px;
            margin-top: 3px;
          }
        }
      }
    }
  }
}

.Blocks {
  width: 1160px;
  padding: 20px 20px;
  // height: 1460px;
  background: #000000;
  border-radius: 16px 16px 16px 16px;
  .Block_Top {
    margin-bottom: 24px;
    display: flex;
    span {
      flex: 1;
    }
    span:nth-child(1) {
      font-size: 18px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #fff;
      line-height: 24px;
      -webkit-background-clip: text;
      b {
        margin-left: 4px;
        font-size: 18px;
        color: #fff;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      }
    }
  }
  .Block_list {
    .block_list_Top {
      display: flex;
      width: 1120px;
      height: 60px;
      background: #14151a;
      border-radius: 10px 10px 10px 10px;
      opacity: 1;
      li {
        font-size: 16px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898b8d;
        height: 60px;
        line-height: 60px;
        -webkit-background-clip: text;
        // flex: 0 0 13%;
        text-align: center;
      }
      .xila {
        position: relative;
      }
      li:nth-child(1) {
        width: 12%;
        text-align: left;
        margin-left: 20px;
      }
      li:nth-child(2) {
        width: 12%;
      }
      li:nth-child(3) {
        width: 12%;
      }
      li:nth-child(4) {
        width: 20%;
      }
      li:nth-child(5) {
        width: 13%;
      }
      li:nth-child(6) {
        width: 13%;
      }
      li:nth-child(7) {
        width: 18%;
      }
    }
  }
  .Block_List_center {
    ul {
      height: 620px;
      padding: 0 12px;
      li:last-child {
        border-bottom: none;
      }
      li {
        display: flex;
        height: 62px;
        border-bottom: 1px solid #22252e;
        line-height: 62px;
        p {
          font-size: 14px;
          font-family: SF Pro Text-Regular, SF Pro Text;
          font-weight: 400;
          -webkit-background-clip: text;
          // flex: 0 0 14%;
          text-align: center;
          span {
            display: inline-block;
          }
          img {
            border-radius: 50%;
          }
          // .active{
          //   color: #898b8d;
          // }
        }
      }
      li:nth-child(10) {
        // border-bottom: none !important;
      }
      p:nth-child(1) {
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        text-align: left;
        cursor: pointer;
        width: 12%;
        margin-left: 10px;
      }
      p:nth-child(1):hover,
      p:nth-child(2):hover,
      p:nth-child(5):hover {
        color: #00e79a;
        cursor: pointer;
        a {
          color: #00e79a;
        }
      }
      p:nth-child(2) {
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        width: 12%;
        cursor: pointer;
        a {
          color: #fff;
        }
      }
      p:nth-child(3):hover {
        .Hover1 {
          display: block !important;
        }
      }
      p:nth-child(3) {
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898b8d;
        width: 12%;
        position: relative;
        cursor: default;
        .Hover1 {
          display: none;
          .Hover {
            width: 196px !important;
            padding: 3px 10px;
            display: inline-block;
            line-height: 20px;
            position: absolute;
            top: -10px;
            left: 0px;
            background-color: #3c485c;
            border-radius: 5px;
            i {
              position: absolute;
              top: 18px;
              left: 40%;
              transform: rotate(180deg);
              color: #3c485c;
            }
          }
        }
      }
      p:nth-child(4) {
        width: 20%;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898b8d;
        //cursor: pointer;
      }
      p:nth-child(5) {
        width: 13%;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;
      }
      .active {
        color: #fff !important;
        cursor: pointer;
      }
      .active:hover {
        color: #00e79a !important;
      }
      p:nth-child(6) {
        width: 13%;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        // color: #ffffff;
      }
      p:nth-child(7) {
        width: 18%;
        // border: 1px solid red;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898b8d;
        img {
          margin-top: 20px;
          // margin-right: 6px;
        }
      }
    }
  }
  .Block_List_Bottom {
    margin-top: 660px;
  }
}
.yanca {
  color: #898b8d !important;
}
@font-face {
  font-family: "aaa";
  src: url("../../../assets/font/NotoSans-Regular.ttf");
}
.el-pagination {
  display: flex;
  justify-content: right;
  ::v-deep button {
    min-width: 24px !important;
    height: 24px !important;
    font-size: 12px;
    color: #fff !important;
    background: none !important;
    // background: #3c485c !important;
    border-radius: 4px 4px 4px 4px !important;
  }
  ::v-deep ul {
    li {
      min-width: 24px !important;
      height: 24px !important;
      background: none !important;
      //border-radius: 4px 4px 4px 4px !important;
      font-size: 12px;
      font-family: aaa;
      font-weight: 400 !important;
      color: #ffffff !important;
      line-height: 20px !important;
      margin: 0 4px !important;
      padding: 2px 8px !important;
    }
    .active {
      background: #22252e !important;
    }
    .more::before {
      line-height: 20px !important;
    }
  }
}
</style>
